import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./Home/App";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import OutstandingAward from "./Outstanding/Outstanding";
import EliteAwards from "./Elite/Elite";
import ExcellencyAwards from "./Excellency/Excellency";
import Media from "./Media/Media";
import { Media2024 } from "./Media/Media2024/Media2024";
import Header from "./Shared/header/Header";
import { Media2025 } from "./Media/Media2025/Media2025";

const router = createBrowserRouter([
  {
    path: "/",
    Component: App,
  },
  {
    path: "outstanding",
    Component: OutstandingAward,
  },
  {
    path: "elite",
    Component: EliteAwards,
  },
  {
    path: "excellence",
    Component: ExcellencyAwards,
  },
  {
    path: "media",
    Component: Media,
  },
  {
    path: "media/2024",
    Component: Media2024,
  },
  {
    path: "media/2025",
    Component: Media2025,
  },
]);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <div>
    <div className="container">
      <RouterProvider router={router} />
    </div>
  </div>
);

reportWebVitals();
